import React from 'react'
import PropTypes from 'prop-types'
import { AddToTrolley } from '@sainsburys-tech/bolt'
import { useAddToTrolleyContext } from '../../providers/AddToTrolleyContext/AddToTrolleyContext'

const FableAddToTrolleyButton = props => {
  const { productId, bundleItems, quantity = 1, trackingParams, onClick } = props
  const { setAddToTrolleyState } = useAddToTrolleyContext()
  const { Button } = AddToTrolley

  const onAddToTrolleyClick = () => {
    // Call additional onClick functions if passed in via props
    if (onClick) onClick()

    setAddToTrolleyState({
      show: true,
      modalProps: {
        productId,
        bundleItems: bundleItems?.length > 0 ? bundleItems : undefined,
        quantity,
        trackingParams
      }
    })
  }

  const extendedButtonProps = {
    ...props,
    enableDefaultClick: false, // Prevent the light box from opening
    onClick: () => onAddToTrolleyClick() // Override the onClick function to open the Fable ATT Drawer
  }

  return <Button data-test='add-to-trolley-button' data-youreko='att-button' {...extendedButtonProps} />
}

FableAddToTrolleyButton.propTypes = {
  productId: PropTypes.string.isRequired,
  bundleItems: PropTypes.arrayOf(PropTypes.string),
  quantity: PropTypes.number,
  onClick: PropTypes.func
}

export default FableAddToTrolleyButton
